<template>
  <div class="article articleHeading position-relative">
    <h3 :class="classes" v-if="!dynamic" v-html="blockData.value" />

    <div v-else>
      <h3
        :class="{
          classes,
          'text-info': !blockData.value
        }"
        v-if="!editingData"
        v-html="difference"
      />
      <Textarea autofocus v-else v-model="form.value" />

      <Actions
        v-if="showActions"
        :block="blockData"
        :editing="editingData"
        v-on:edit="() => (editingData = !editingData)"
        v-on:save="save"
        :saving="saving"
        v-on:cancel="cancel"
        v-on:destroy="destroy"
        :deletable="deletable"

        :asset-id="asset.id"
        :model="asset.model"
      />
    </div>
  </div>
</template>

<script>
import contractHelpers from '@/Mixins/contractHelpers';
import Actions from '@/Pages/Asset/Contract/Actions/Actions';
import Textarea from '@/Shared/Inputs/Textarea';

export default {
  mixins: [contractHelpers],

  components: {
    Actions,
    Textarea,
  },

  props: {
    dynamic: {
      type: Boolean,
      default: false,
    },
    block: Object,
    blocks: Array,
    definitions: Array,
    showActions: Boolean,
    asset: Object,
    blockReference: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      blockData: this.block,

      editingData: false,
      versions: false,
      comments: false,

      errors: null,
      saving: false,

      form: {
        value: this.block.value,
      },
    };
  },

  watch: {
    block(block) {
      this.form.value = block.value;
    },
  },

  computed: {
    difference() {
      const latest = this.blockData.latest_version;

      let text = this.form.value || 'Enter Details';
      if (latest) text = this.compareValue(this.form.value, latest.value);
      let colour = '';

      switch (this.blockData.state) {
        case 'incomplete':
          colour = 'text-danger';

          break;
        case 'pending':
          colour = this.userHasRole('approver') ? 'text-danger' : 'text-success';

          break;
        case 'originatorApproved':
          colour = this.state.withCounterparty ? 'text-danger' : 'text-success';

          break;
        case 'counterpartyApproved':
          colour = !this.state.withCounterparty ? 'text-danger' : 'text-success';

          break;
        case 'accepted':
          colour = this.asset.state === 'executed' ? 'text-body' : 'text-success';
          text = this.form.value;

          break;
        default:
          colour = 'text-danger';

          break;
      }

      return `<span class="${colour}">${text}</span>`;
    },
  },

  methods: {
    save() {
      this.saving = true;

      this.$nextTick(() => {
        window.axios
          .put(`/contract-block/${this.block.id}`, this.form)
          .then((response) => {
            this.saving = false;
            this.editingData = this.userHasRole('approver');
            this.blockData = response.data;
            this.fetchAssetState(this.asset.id);
          })
          .catch((error) => {
            this.saving = false;
            // this.errors = error.response.data.errors;
            throw new Error(error);
          });
      });
    },

    cancel() {
      this.form.value = this.block.value;
      this.editingData = false;
    },

    destroy() {
      this.saving = true;

      this.$nextTick(() => {
        window.axios
          .delete(`/contract-block/${this.block.id}`)
          .then(() => {
            this.saving = false;
            this.editingData = false;

            this.$emit('destroy', this.block.contract_reference);
          })
          .catch((error) => {
            this.saving = false;
            this.errors = error.response.data.errors;
            throw new Error(error);
          });
      });
    },
  },
};
</script>
